module.exports = __webpack_public_path__ + "static/media/ios-baseball.484cd4bd.svg";